import { useState, ChangeEvent, FocusEvent, useRef, KeyboardEvent, useEffect } from 'react'
import Paper from '@mui/material/Paper'
import IconButton from '@mui/material/IconButton'
import MenuIcon from '@mui/icons-material/Menu'
import SearchIcon from '@mui/icons-material/Search'
import ErrorIcon from '@mui/icons-material/Error'
import CloseIcon from '@mui/icons-material/Close'
import Tooltip from '@mui/material/Tooltip'
import { ReactComponent as HamburgerIcon } from '../../icon/map_menu_hamburger.svg'
import { useTranslation } from 'react-i18next'
import TextField from '@mui/material/TextField'
import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'
import Stack from '@mui/material/Stack'

import Popper from '@mui/material/Popper'
import ListItem from '@mui/material/ListItem'
import ListItemText from '@mui/material/ListItemText'

import useMapUpperBar from '../../hooks/map/useMapUpperBar'
import useMapStore from '../../stores/useMapStore'
import * as validate from '../../util/validate'
import * as utils from '../../util/utilityFunction'
import { ReactComponent as DooDeeIcon } from '../../icon/doodee_not_found.svg'
import { Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import useMapUpperBarStore from '../../stores/useMapUpperBarStore'

type MapUpperBarProps = {
    onClickHamburger: () => void
    onClickInfo: () => void
    showDialog: (message: string) => void
    searchStationByLatLon?: (lon: number, lat: number, alertContent: string) => void
    drawStationFromSearchKeyword?: (lon: number, lat: number, data: SearchResultType) => void
}
const MapUpperBarCustom = (props: MapUpperBarProps) => {
    const { onClickHamburger, onClickInfo, showDialog, searchStationByLatLon, drawStationFromSearchKeyword } = props
    const { t } = useTranslation()
    const mapStore = useMapStore()
    const mapUpperBarStore = useMapUpperBarStore()
    const mapUpperBar = useMapUpperBar({ showDialog, drawStationFromSearchKeyword })
    const theme = useTheme()

    const refElement = useRef<any>(null)
    const refPaper = useRef<HTMLDivElement>(null)
    // const [anchorEl, setAnchorEl] = useState<any>(null)
    // const [anchorEl2, setAnchorEl2] = useState<any>(null)
    const [dataSource, setDataSource] = useState<AdministrativeType[]>([])
    const [dataObject, setDataObject] = useState<AdministrativeType>()
    const [inputValue, setInputValue] = useState<string>('')
    const [currentFocus, setCurrentFocus] = useState<number>(-1)

    const open = Boolean(mapUpperBarStore.anchorElResult) && dataSource.length > 0
    const id = open ? 'result-popover' : undefined
    const open2 = Boolean(mapUpperBarStore.anchorElNoResult)
    const id2 = open2 ? 'noOption-popover' : undefined
    const propStyle: PropStyle = { paperWidth: refPaper.current?.offsetWidth }
    const classes = useStyles(propStyle)

    const onFocus = (e: FocusEvent<HTMLInputElement>) => {
        refElement.current = e.currentTarget
        const value = e.target.value
        const { isValidLongitude, isValidateDMS } = getValidate(value)

        if (isValidLongitude || isValidateDMS) {
            // console.log('isValid')
        } else {
            if (value.length >= 3) {
                mapUpperBar.callServiceSearchAdministrativeAutocomplete(value).then((res) => {
                    if (res) {
                        setDataSource(res)
                        mapUpperBarStore.setAnchorElResult(refElement.current)
                    } else {
                        clear()
                    }
                })
            }
        }
    }

    const onChange = (e: ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value
        setInputValue(value)
        const { isValidLongitude, isValidateDMS } = getValidate(value)
        if (isValidLongitude || isValidateDMS) {
            setDataSource([])
            mapUpperBarStore.setAnchorElResult(null)
            mapUpperBarStore.setAnchorElNoResult(null)
        } else {
            if (value.length >= 3) {
                setTimeout(() => {
                    mapUpperBar.callServiceSearchAdministrativeAutocomplete(value).then((res) => {
                        if (res) {
                            setDataSource(res)
                            mapUpperBarStore.setAnchorElResult(refElement.current)
                            mapUpperBarStore.setAnchorElNoResult(null)
                        } else {
                            setDataSource([])
                            mapUpperBarStore.setAnchorElResult(null)
                            mapUpperBarStore.setAnchorElNoResult(refElement.current)
                        }
                    })
                }, 200)
            } else {
                setTimeout(() => {
                    setDataSource([])
                    setDataObject(undefined)
                    mapUpperBarStore.setAnchorElNoResult(null)
                }, 200)
            }
        }
    }

    const onKeyDown = (e: KeyboardEvent<HTMLImageElement>) => {
        if (e.code === 'Enter') {
            if (dataSource.length > 0 && currentFocus > -1) {
                globalThis.document.getElementById(`listItem-${currentFocus}`)?.click()
                globalThis.document.getElementById('inputText')?.blur()
            } else {
                onClickSearch()
                globalThis.document.getElementById('inputText')?.blur()
            }
        }

        if (e.keyCode === 40) {
            const num = currentFocus + 1
            if (num <= dataSource.length - 1) {
                globalThis.document
                    .getElementById(`listItem-${currentFocus}`)
                    ?.setAttribute('style', 'background-color: none')
                globalThis.document
                    .getElementById(`listItem-${num}`)
                    ?.setAttribute('style', 'background-color: #cec9c9')
                globalThis.document.getElementById(`listItem-${num}`)?.focus({ preventScroll: false })
                setCurrentFocus(num)
            }
        }

        if (e.keyCode === 38) {
            const num = currentFocus - 1
            if (num >= 0) {
                globalThis.document
                    .getElementById(`listItem-${currentFocus}`)
                    ?.setAttribute('style', 'background-color: none')
                globalThis.document
                    .getElementById(`listItem-${num}`)
                    ?.setAttribute('style', 'background-color: #cec9c9')
                globalThis.document.getElementById(`listItem-${num}`)?.focus({ preventScroll: false })
                setCurrentFocus(num)
            }
        }
    }

    const onBlur = (e: any) => {
        const nativeEvent = e?.nativeEvent
        const nodeName = nativeEvent?.relatedTarget?.firstChild?.nodeName ?? ''
        if (
            nativeEvent?.relatedTarget?.nodeName === 'CANVAS' ||
            nativeEvent?.relatedTarget?.nodeName === 'BUTTON' ||
            nativeEvent?.relatedTarget?.nodeName === 'DIV' ||
            nodeName === 'CANVAS' ||
            nodeName === 'svg'
        ) {
            setDataSource([])
            mapUpperBarStore.setAnchorElResult(null)
            mapUpperBarStore.setAnchorElNoResult(null)
        }
    }

    const onClickItem = (data: AdministrativeType) => {
        setInputValue(data.name)
        mapUpperBarStore.setAnchorElResult(null)
        setDataObject(data)
        const adminLevel = data?.adminLevel
        const adminId = data?.adminId
        mapUpperBar.callServiceSearchAdministrative(adminLevel, adminId).then((res) => {
            setDataSource([])
            setDataObject(undefined)
        })
    }

    const onClickClear = () => {
        clear()
    }

    const clear = () => {
        setInputValue('')
        mapUpperBarStore.setAnchorElResult(null)
        mapUpperBarStore.setAnchorElNoResult(null)
        setDataObject(undefined)
        setCurrentFocus(-1)
    }

    const onClickSearch = () => {
        const { isValidLongitude, isValidateDMS, dms } = getValidate(inputValue)
        if (isValidLongitude) {
            const { longitude, latitude } = utils.separateWordCommaLonLat(inputValue)
            searchStationByLatLon?.(longitude, latitude, t('ALERT.CONTENT.STATION_NOT_FOUND_LATLONG'))
            mapUpperBarStore.setAnchorElResult(null)
            mapUpperBarStore.setAnchorElNoResult(null)
            mapStore.setMapUpperBar(false)
        } else if (isValidateDMS) {
            const convert = utils.convertDMSToLonLat(dms.x, dms.y)
            searchStationByLatLon?.(convert.longitude, convert.latitude, t('ALERT.CONTENT.STATION_NOT_FOUND_LATLONG'))
            mapUpperBarStore.setAnchorElResult(null)
            mapUpperBarStore.setAnchorElNoResult(null)
            mapStore.setMapUpperBar(false)
        } else {
            if (dataObject) {
                const adminLevel = dataObject?.adminLevel
                const adminId = dataObject?.adminId
                mapUpperBar.callServiceSearchAdministrative(adminLevel, adminId).then((res) => {
                    setDataSource([])
                    setDataObject(undefined)
                })
            }
        }
    }

    const getValidate = (value: string) => {
        const isValidLongitude = validate.validateFormatLatLong(value)
        const dms = utils.separateWordCommaDMS(value)
        const isValidateDMS = validate.validateFormatDMS(dms.x, dms.y)
        return {
            isValidLongitude,
            isValidateDMS,
            dms,
        }
    }

    useEffect(() => {
        if (mapStore.resetMapUpperBar) {
            clear()
        }
    }, [mapStore.resetMapUpperBar])

    return (
        <>
            <Paper component="div" ref={refPaper} className={classes.paper}>
                <TextField
                    id="inputText"
                    className={classes.textField}
                    size="small"
                    placeholder={t('LABEL.MAP.SEARCH_IN_MAP')}
                    onFocus={onFocus}
                    onChange={onChange}
                    onKeyDown={onKeyDown}
                    onBlur={onBlur}
                    value={inputValue}
                    inputProps={{ 'aria-label': 'search google maps' }}
                    InputProps={{
                        startAdornment: (
                            <Tooltip title={t('LABEL.MAP.TOOLS.MENU') ?? ''} placement="top">
                                <IconButton
                                    color="primary"
                                    sx={{ p: '10px', marginLeft: '4px' }}
                                    aria-label="menu"
                                    onClick={onClickHamburger}
                                >
                                    <HamburgerIcon style={{ width: '18px' }} />
                                </IconButton>
                            </Tooltip>
                        ),
                        endAdornment: (
                            <Stack direction="row" alignItems="center">
                                <Tooltip title={t('TOOLTIP.CLEAR') ?? ''} placement="top">
                                    <IconButton sx={{ p: '5px' }} aria-label="search" onClick={onClickClear}>
                                        <CloseIcon />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title={t('TOOLTIP.SEARCH') ?? ''} placement="top">
                                    <IconButton sx={{ p: '5px' }} aria-label="search" onClick={onClickSearch}>
                                        <SearchIcon />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title={t('LABEL.MAP.TOOLS.INFORMATION') ?? ''} placement="top">
                                    <IconButton
                                        sx={{ p: '5px', marginRight: '4px' }}
                                        aria-label="directions"
                                        onClick={onClickInfo}
                                    >
                                        <ErrorIcon />
                                    </IconButton>
                                </Tooltip>
                            </Stack>
                        ),
                    }}
                />
            </Paper>

            {dataSource.length > 0 ? (
                <Popper id={id} open={open} anchorEl={mapUpperBarStore.anchorElResult}>
                    <Paper
                        component="div"
                        sx={{
                            width: refPaper.current?.offsetWidth,
                            maxHeight: 400,
                            bgcolor: '#FFF ',
                            overflow: 'hidden',
                            marginLeft: '15px',
                            py: 2,
                        }}
                    >
                        {dataSource.map((item, index) => (
                            <ListItem
                                id={`listItem-${index}`}
                                key={index}
                                component="div"
                                disablePadding
                                sx={{
                                    width: 'inherite',
                                    cursor: 'pointer',
                                    px: 1,
                                    '&:hover': {
                                        backgroundColor: '#cec9c9',
                                    },
                                }}
                                onClick={() => onClickItem(item)}
                            >
                                <ListItemText primary={`${item.name}`} />
                            </ListItem>
                        ))}
                    </Paper>
                </Popper>
            ) : (
                <Popper id={id2} open={open2} anchorEl={mapUpperBarStore.anchorElNoResult}>
                    <Paper
                        component="div"
                        sx={{
                            width: refPaper.current?.offsetWidth,
                            maxHeight: 400,
                            bgcolor: '#FFF ',
                            overflow: 'hidden',
                            marginLeft: '15px',
                            py: 2,
                        }}
                    >
                        <div style={{ color: theme.palette.text.primary, display: 'flex', justifyContent: 'center' }}>
                            <Stack spacing={2}>
                                <DooDeeIcon />
                                <Typography sx={{ fontSize: '14px', fontWeight: 400, color: '#000' }}>
                                    {t('ALERT.CONTENT.STATION_NOT_AUTOCOMPLETE')}
                                </Typography>
                            </Stack>
                        </div>
                    </Paper>
                </Popper>
            )}
        </>
    )
}

type PropStyle = {
    paperWidth?: number | string
}
const useStyles = makeStyles((theme: Theme) => ({
    paper: {
        display: 'flex',
        width: '100%',
        [theme.breakpoints.up('md')]: {
            width: '600px',
        },
    },
    textField: {
        width: '100% !important',
        '& .MuiOutlinedInput-root': {
            paddingLeft: '0px !important',
            paddingRight: '0px !important',
        },
        '& .MuiOutlinedInput-notchedOutline': {
            border: 0,
            borderStyle: 'none',
        },
    },
    listItem: {
        backgroundColor: 'green',
        '&:hover': {
            backgroundColor: 'gray',
        },
    },
    autocompleteActive: {
        '&:active': {
            backgroundColor: '#cec9c9',
        },
    },
}))
export default MapUpperBarCustom
